var _defs, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLumenLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "lumenCutout",
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 18.5,
    width: 24,
    height: 88
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 18.5,
    width: 24,
    height: 88,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 70,
    fontFamily: "'Inter', sans-serif",
    fontSize: 10,
    fontWeight: 300,
    fill: "black",
    textAnchor: "middle",
    transform: "rotate(-90 40 60)",
    letterSpacing: 10
  }, "\r\n        Lumen\r\n      ")))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 18.5,
    width: 24,
    height: 88,
    rx: 3,
    fill: "#FFFFFF",
    mask: "url(#lumenCutout)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 96,
    width: 40,
    height: 10,
    rx: 2.5,
    fill: "#A3B0D5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 82,
    width: 28,
    height: 10,
    rx: 2.5,
    fill: "#C4CCE5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 68,
    width: 16,
    height: 10,
    rx: 2.5,
    fill: "#DDE3F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumenLogoWhite);
export default __webpack_public_path__ + "static/media/lumen-logo-white.c620a4b8520fe64e429c0519b5623c52.svg";
export { ForwardRef as ReactComponent };